import { createApp } from 'vue'
import App from './App.vue'
//import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import router from './helpers/router' // Adapté si tes routes sont exportées séparément
import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'
import VueBlobJsonCsv from 'vue-json-excel3'
import { config } from './helpers'
import { Auth0Plugin } from './auth'

import './assets/main.scss'
import '@vuepic/vue-datepicker/dist/main.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChartPie, faChartBar, faClipboardList, faUserPlus, faSignInAlt,
  faSignOutAlt, faUser, faAngleDown, faAngleUp, faPlus, faCheck,
  faExclamationTriangle, faChevronLeft, faChevronRight, faTasks,
  faQuestionCircle, faBell, faExternalLinkAlt, faBolt, faBookOpen, faCamera
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Font Awesome setup
library.add(
    faChartPie, faChartBar, faClipboardList, faUserPlus, faSignInAlt,
    faSignOutAlt, faUser, faAngleDown, faAngleUp, faPlus, faCheck,
    faExclamationTriangle, faChevronLeft, faChevronRight, faTasks,
    faQuestionCircle, faBell, faExternalLinkAlt, faBolt, faBookOpen, faCamera
)

// Créer l'app Vue 3
const app = createApp(App)

// Créer le routeur Vue 3
// const router = createRouter({
//   history: createWebHistory(),
//   routes
// })

// Fix for dropdowns in Webkit browsers
const isWebKit = !window.chrome && /webkit/i.test(navigator.userAgent)

function closeDropdown(dropdown) {
  if (dropdown?.classList.contains('is-active')) {
    dropdown.querySelector('.dropdown-trigger button')?.click()
  }
}

function isMultiSelect(dropdown) {
  return dropdown?.querySelector('input[type="checkbox"]') !== null
}

if (isWebKit) {
  document.addEventListener('click', (e) => {
    const item = e.target.closest('.dropdown-item')
    if (item) {
      const dropdown = item.closest('.dropdown')
      if (!isMultiSelect(dropdown)) {
        closeDropdown(dropdown)
      }
      return
    }

    if (!e.target.closest('.dropdown')) {
      document.querySelectorAll('.dropdown.is-active').forEach(closeDropdown)
    }
  })
}

// Auth0 plugin
app.use(Auth0Plugin, {
  domain: config.auth0Domain,
  clientId: config.auth0ClientId,
  authorizationParams: {
    audience: config.auth0Audience
  },
  onRedirectCallback: appState => {
    router.push(appState?.targetUrl || window.location.pathname)
  }
})

app
    .use(store)
    .use(router)
    .use(createVfm())
    .component('downloadExcel', VueBlobJsonCsv)
    .component('awesome-icon', FontAwesomeIcon)
    .mount('#app')
